import { get, post } from './utils.service'

export const askAssistant = async (body) => {
    const res = await post(`/assistant/ask`, { ...body })
    return await res?.json()
}

export const getAssistantConversations = async () => {
    const res = await get(`/assistant/conversations`)
    return await res?.json()
}

export const sendAssistantFeedback = async (body) => {
    const res = await post(`/assistant/feedback`, { ...body })
    return await res?.json()
}

export const checkAssistantLogsStatus = async (body) => {
    const res = await post(`/assistant/logs-status`, { ...body })
    return await res?.json()
}
